import React from 'react';
import { companions } from '../data/mockData';
import { CompanionCard } from './CompanionCard';
import { ArrowRight } from 'lucide-react';
export function FeaturedGrid() {
  return <section id="featured" className="py-20 bg-dark-900 relative" data-id="element-107">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-108">
        {/* Section Header */}
        <div className="text-center mb-16" data-id="element-109">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-110">
            精选伴游女郎 <span className="text-gold-500" data-id="element-111">.</span>
          </h2>
          <div className="w-24 h-1 bg-gold-500 mx-auto rounded-full mb-6" data-id="element-112"></div>
          <p className="text-gray-400 max-w-2xl mx-auto" data-id="element-113">
            为您精心挑选的顶级伴游，每一位都经过严格的身份核验与面试，确保为您带来最完美的陪伴体验。
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8" data-id="element-114">
          {companions.map((companion, index) => <CompanionCard key={companion.id} companion={companion} index={index} data-id="element-115" />)}
        </div>

        {/* View More Button */}
        <div className="mt-16 text-center" data-id="element-116">
          <button className="group inline-flex items-center px-8 py-3 border border-gold-500 text-gold-500 hover:bg-gold-500 hover:text-dark-900 transition-all duration-300 rounded uppercase tracking-wider font-medium" data-id="element-117">
            查看更多伴游
            <ArrowRight className="ml-2 w-4 h-4 transform group-hover:translate-x-1 transition-transform" data-id="element-118" />
          </button>
        </div>
      </div>
    </section>;
}